<template>
    <UModal
        v-model:open="open"
        :title="type === 'insert' ? 'Vložit nový záznam' : 'Editace záznamu'"
        :ui="{
            footer: 'justify-end',
            content: '!max-w-3xl ',
            body: 'max-h-[500px] overflow-y-auto',
        }"
        :close="{
            variant: 'outline',
            class: 'rounded-full cursor-pointer',
        }"
    >
        <UButton
            v-if="type === 'insert'"
            icon="prime:plus"
            color="neutral"
            size="md"
            variant="ghost"
            class="font-promedium text-black-text cursor-pointer rounded-none hover:bg-black-text hover:text-white transition-none"
        >
            <span> Nový záznam </span>
        </UButton>
        <UIcon
            v-else
            name="prime:pencil"
            class="size-5 group-hover:size-6"
        />
        <template #body>
            <InsertData
                :edit-item="editItem"
                @close="open = false"
            />
        </template>
    </UModal>
</template>

<script lang="ts" setup>
const open = ref(false)

watch(open, () => {
    if (open.value) {
        console.log(props)
    }
})

const props = defineProps<{
    type: "insert" | "edit"
    editItem?: TableItem
}>()
</script>

<style scoped></style>
